import { emperor } from '~/services';


export const getLastUploadedDate = async () => {
  return await emperor.get('deeplink-last-upload-date');
};
